import { render } from "./userNavigationSkelet.vue?vue&type=template&id=5a4a80a6"
const script = {}

import exportComponent from "/var/www/profixone-instant-clone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__